/*
 * @author Lemuel Raganas <lemuel.raganas@mediacorp.com.sg>
 **/

enum Host {
  LOCALHOST = "localhost",
  STAGING = "staging",
  PRODUCTION = "production",
  TEST = "test",
  UNKNOWN = "unknown",
}

class KnownHost {
  static LOCALHOST = "http://localhost";
  static STAGING = "https://beta-www.channelnewsasia.com";
  static PRODUCTION = "https://www.channelnewsasia.com";
  static PRODUCTION_STUDIO = "https://cmstudio.wcms.mediacorp.sg";
  static TEST = "http://127.0.0.1";
}

class HostResolverUtil {
  toHost(host: string): Host {
    if (host === undefined) {
      return Host.PRODUCTION;
    }

    if (this.isAbsolute(host)) {
      if (host.startsWith(KnownHost.LOCALHOST)) {
        return Host.LOCALHOST;
      }

      if (host.startsWith(KnownHost.STAGING)) {
        return Host.STAGING;
      }

      if (host.startsWith(KnownHost.PRODUCTION)) {
        return Host.PRODUCTION;
      }

      if (host.startsWith(KnownHost.TEST)) {
        return Host.TEST;
      }

      return Host.UNKNOWN;
    }

    switch (host) {
      case "unknown":
        return Host.UNKNOWN;
      case "localhost":
        return Host.LOCALHOST;
      case "staging":
        return Host.STAGING;
      case "test":
        return Host.TEST;
      default:
        return Host.PRODUCTION;
    }
  }

  getHost(host: Host): string {
    switch (host) {
      case Host.UNKNOWN:
        return undefined;
      case Host.LOCALHOST:
        return KnownHost.LOCALHOST;
      case Host.STAGING:
        return KnownHost.STAGING;
      case Host.TEST:
        return KnownHost.TEST;
      default:
        return KnownHost.PRODUCTION;
    }
  }

  resolve(host: string): string {
    if (this.isAbsolute(host)) {
      return host;
    }

    const ehost: Host = this.toHost(host);
    return this.getHost(ehost);
  }

  isAbsolute(host: string): boolean {
    if (host === undefined) {
      return false;
    }

    if (host.startsWith("http://") || host.startsWith("https://")) {
      return true;
    }

    return false;
  }
}

const HostResolver = new HostResolverUtil();

export { Host, HostResolver, KnownHost };
